import ChangePasswordDialogModule from './change-password.module'

export default ChangePasswordDialogModule
